import type { ElementType } from "react";
import type { OverridableComponent, OverrideProps } from "@mui/material/OverridableComponent";
import type { TypographyOwnProps } from "@mui/material/Typography";
import MuiTypography from "@mui/material/Typography";

interface ITypographyTypeMap<AdditionalProps = NonNullable<unknown>, RootComponent extends ElementType = "span"> {
    props: AdditionalProps & Omit<TypographyOwnProps, "color"> & { color?: never };
    defaultComponent: RootComponent;
}

export type TypographyProps<
    RootComponent extends ElementType = ITypographyTypeMap["defaultComponent"],
    AdditionalProps = NonNullable<unknown>
> = OverrideProps<ITypographyTypeMap<AdditionalProps, RootComponent>, RootComponent> & {
    component?: ElementType;
};

export const Typography = MuiTypography as OverridableComponent<ITypographyTypeMap>;
